module.exports = __webpack_public_path__ + "static/media/avatar35.4c875db6.png";